// export const apiUri = "http://127.0.0.1:3002";
// export const apiUri = "http://172.19.224.197:3001";
// export const apiUri = "http://192.168.1.151:3001"
// export const modelUri = "http://172.19.224.197:5000";
export const apiUri = "https://api-aimootcourt.centralindia.cloudapp.azure.com";
export const modelUri = "https://model-aimootcourt.centralindia.cloudapp.azure.com";

